import { useCallback, useEffect, useRef, useState } from 'react';

const DEFAULT_RESET_DELAY_MS = 2000;

const useCopy = (resetDelayMs = DEFAULT_RESET_DELAY_MS) => {
  const [copied, setCopied] = useState(false);

  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(
    () => () => {
      clearTimeout(timeoutRef.current);
    },
    []
  );

  const copy = useCallback(
    async (text: string): Promise<void> => {
      try {
        await navigator.clipboard.writeText(text);
      } catch {
        return;
      }
      setCopied(true);
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setCopied(false), resetDelayMs);
    },
    [resetDelayMs]
  );

  return { copy, copied };
};

export default useCopy;
